import { useForm } from "react-hook-form"
import TextArea from "../../Components/CommonCommponents/TextArea"
import CandodateService from "../../Service.js/CandidateService"
import { useEffect } from "react"
import toast from "react-hot-toast";
import { Button } from "antd";
import { useState } from "react";

const AboutMe = (props) => {
    const {
        register,
        control,
        setValue,
        setError,
        handleSubmit,
        watch,
        reset,
        formState: { errors },
    } = useForm()
    const [candidateData, setCandidateData] = useState();

    const getCandidatePersonalDetails = async () => {
        await CandodateService.getAboutMeDetailsById()
            .then(
                (response) => {
                    console.log("response", response.data.data);
                    getData(response.data.data)
                    setCandidateData(response.data.data)
                    //setCandidateDetails(response.data.data);
                }
            )
            .catch((error) => {
            });
    }
    const getData = (data) => {
        console.log("testdata", data);
        setValue("about_me", data?.about_me)
    }
    useEffect(() => {
        getCandidatePersonalDetails()
    }, [])
    const onSubmit = async (data) => {
        await CandodateService.updateCandidateDetails(data,candidateData?.id)
            .then(
                (oResponse) => {
                    console.log("oResponse", oResponse);
                    toast.success("Successfully Added!");

                    props.close()
                  
                },
                (error) => {
                    console.log("loginError", error);

                }
            )
            .catch((err) => {
                console.log(err);
                toast.error("Failed To Add")
            });
    }
    return (
        <div>
            <form className=" w-full" onSubmit={handleSubmit(onSubmit)}>
                <div className="w-full mt-8">
                    <TextArea
                        label="About Me"
                        name="about_me"
                        showArrow={true}
                        allowClear
                        rules={{
                            required: "This field is required.",
                        }}
                        className="h-full"
                        control={control}
                    />
                </div>
                <div className="flex flex-wrap justify-end mt-10 ">
                    <Button htmlType="submit" type="submit" className="bg-[#000000] text-white text-base rounded-3xl px-4">Save</Button>
                </div>
            </form>

        </div>
    )

}
export default AboutMe